import EventEmitter from "eventemitter3";
const eventEmitter = /* @__PURE__ */ new EventEmitter();
function onEvent(eventName, handler, options) {
  return (options == null ? void 0 : options.once) ? eventEmitter.once(eventName, handler) : eventEmitter.on(eventName, handler);
}
function offEvent(eventName, handler, options) {
  var _a;
  eventEmitter.removeListener(eventName, handler, (_a = options == null ? void 0 : options.context) != null ? _a : null, options == null ? void 0 : options.once);
}
function emitEvent(eventName, payload) {
  eventEmitter.emit(eventName, payload);
}
export {
  emitEvent,
  offEvent,
  onEvent
};
//# sourceMappingURL=vanilla.mjs.map
